import { render, staticRenderFns } from "./GatewayTable.vue?vue&type=template&id=60bfc1fd&scoped=true"
import script from "./GatewayTable.vue?vue&type=script&lang=js"
export * from "./GatewayTable.vue?vue&type=script&lang=js"
import style0 from "./GatewayTable.vue?vue&type=style&index=0&id=60bfc1fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bfc1fd",
  null
  
)

export default component.exports